export default [
  {
    path: 'daftar',
    name: 'branch list',
    component: () => import('@/views/app/branch/list/page-list.vue'),
    meta: { title: 'Daftar Cabang' },
  },
]
